<template>
  <div id="preview" class="printReward">
    <div class="titlename">代理商消費紀錄統計表</div>
    <table>
      <thead>
        <tr>
          <th>項次</th>
          <th>代理商</th>
          <th>統編</th>
          <th :style="{backgroundColor: 'rgb(205, 205, 205)'}">團(平)</th>
          <th :style="{backgroundColor: 'rgb(205, 205, 205)'}">團(假)</th>
          <th :style="{backgroundColor: 'rgb(205, 205, 205)'}">優惠</th>
          <th :style="{backgroundColor: 'rgb(205, 205, 205)'}">其他</th>
          <th>付費票數</th>
          <th>非團體票數</th>
          <th>總人次</th>
          <th>門票總金額</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="({ name, ID, ticket1, ticket2, ticket3, ticketAllGroup, ticketAllOther, ticketGroupOther, total, count }, r) in records" :key="r">
          <td>{{r+1}}</td>
          <td :style="{textAlign: 'start'}">{{name}}</td>
          <td>{{ID}}</td>
          <td>{{ticket1||'-'}}</td>
          <td>{{ticket2||'-'}}</td>
          <td>{{ticket3||'-'}}</td>
          <td>{{ticketGroupOther||'-'}}</td>
          <td>{{ticketAllGroup||'-'}}</td>
          <td>{{ticketAllOther||'-'}}</td>
          <td>{{count}}</td>
          <td :style="{textAlign:'end'}">{{formatDollarInt(total)}}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr :style="{borderBottom: '1px solid #CACACA'}"></tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  props: ['records']

}
</script>

<style scoped>
table {
  border: 1px solid #CACACA;
  border-collapse: collapse;
}
thead tr {
  background-color: rgb(240, 240, 240);
}
th {
  padding-inline: .5em;
  height: 40px;
}
td {
  border-right: 1px solid #CACACA;
  height: 40px;
  padding-inline: .5em;
}

#preview {
  display: flex;
  flex-direction: column;
  gap: 21px;
  position: fixed;
  top: -60px;
  left: -100vw;
  background-color: #FFFFFF;
  width: 297mm;
  height: 210mm;
  transform: scale(.85);
  z-index: 100;
  padding: 30px 50px;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
}
.titlename {
  color: #5E5E5E;
  font-family: Noto Sans TC;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 4px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
